// src/components/TaskForm.tsx
import React, { useState, useEffect } from "react";
import { Task } from "../types/task";
import { TaskStatus, TaskPriority } from "../types/enum"; // Corrected import to enums

interface TaskFormProps {
  initialTask?: Omit<Task, "id" | "createdAt" | "updatedAt" | "userId"> | null;
  onSubmit: (
    task: Omit<Task, "id" | "createdAt" | "updatedAt" | "userId">
  ) => void;
  submitButtonText?: string;
  // Removed onCancel prop, as TaskDialog will handle closing
  // onCancel?: () => void; // This line is no longer needed
}

const TaskForm: React.FC<TaskFormProps> = ({
  initialTask,
  onSubmit,
  submitButtonText = "Save Task",
  // No longer destructuring onCancel
  // onCancel,
}) => {
  const defaultTask: Omit<Task, "id" | "createdAt" | "updatedAt" | "userId"> = {
    name: "",
    description: "",
    status: TaskStatus.TO_DO,
    priority: TaskPriority.MEDIUM,
    dueDate: undefined,
  };

  const [task, setTask] = useState<
    Omit<Task, "id" | "createdAt" | "updatedAt" | "userId">
  >(initialTask || defaultTask);

  useEffect(() => {
    setTask(initialTask || defaultTask);
  }, [initialTask]);

  const handleInputChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    const { name, value } = e.target;
    setTask((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!task.name.trim()) {
      alert("Task name cannot be empty.");
      return;
    }
    onSubmit(task);
    // TaskDialog will now call onClose after onSubmit is completed.
  };

  return (
    <form onSubmit={handleSubmit} className="task-form">
      <h3>{initialTask ? "Edit Task" : "Add New Task"}</h3>
      <div className="form-group">
        <label htmlFor="name">Task Name:</label>
        <input
          type="text"
          id="name"
          name="name"
          value={task.name}
          onChange={handleInputChange}
          className="form-control"
          required
        />
      </div>
      <div className="form-group mt-3">
        <label htmlFor="description">Description:</label>
        <textarea
          id="description"
          name="description"
          value={task.description || ""}
          onChange={handleInputChange}
          className="form-control"
        />
      </div>
      <div className="form-group mt-3">
        <label htmlFor="status">Status:</label>
        <select
          id="status"
          name="status"
          value={task.status}
          onChange={handleInputChange}
          className="form-control"
        >
          {Object.values(TaskStatus).map((s) => (
            <option key={s} value={s}>
              {s.replace("_", " ")}
            </option>
          ))}
        </select>
      </div>
      <div className="form-group mt-3">
        <label htmlFor="priority">Priority:</label>
        <select
          id="priority"
          name="priority"
          value={task.priority}
          onChange={handleInputChange}
          className="form-control"
        >
          {Object.values(TaskPriority).map((p) => (
            <option key={p} value={p}>
              {p}
            </option>
          ))}
        </select>
      </div>
      <div className="form-group mt-3">
        <label htmlFor="dueDate">Due Date:</label>
        <input
          type="date"
          id="dueDate"
          name="dueDate"
          value={task.dueDate || ""}
          onChange={handleInputChange}
          className="form-control"
        />
      </div>
      <button type="submit" className="btn btn-primary mt-3">
        {submitButtonText}
      </button>
      {/* The Cancel button is now managed by the TaskDialog wrapper */}
      {/* If you still want a cancel button *inside* the form, it would call a prop from TaskDialog */}
      {/* For now, we'll rely on the X button and outside click */}
      {/* The onCancel prop would no longer be defined on TaskFormProps either */}
      {/* {onCancel && (
        <button
          type="button"
          onClick={onCancel}
          className="btn btn-secondary ml-2"
        >
          Cancel
        </button>
      )} */}
    </form>
  );
};

export default TaskForm;
